import { NgModule } from '@angular/core';

import { DistributorStockRoutingModule } from './distributor-stock.routing';
import { ListDistributorStockComponent } from './list-distributor-stock/list-distributor-stock.component';
import { UpdateDistributorStockComponent } from './update-distributor-stock/update-distributor-stock.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListDistributorStockComponent, UpdateDistributorStockComponent],
  imports: [SharedModule, DistributorStockRoutingModule]
})
export class DistributorStockModule {}
